import { render, staticRenderFns } from "./EstablishAtDescriptionModal.vue?vue&type=template&id=054eaaf2"
import script from "./EstablishAtDescriptionModal.vue?vue&type=script&lang=js"
export * from "./EstablishAtDescriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports